import { render } from "./IconRotationScreen.vue?vue&type=template&id=cdf19302&scoped=true"
const script = {}

import "./IconRotationScreen.vue?vue&type=style&index=0&id=cdf19302&lang=scss&scoped=true"

import exportComponent from "F:\\PROMODUL\\Projets\\APP.LUMIERE+\\code\\lumiere_plus\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdf19302"]])

export default __exports__